import { render } from "./MyCourse.vue?vue&type=template&id=6f3bd9a0"
import script from "./MyCourse.vue?vue&type=script&lang=js"
export * from "./MyCourse.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__